import React from "react";
import * as stylex from "@stylexjs/stylex";
import { timeAgo } from "~/utils/timeAgoLocaleEn";
import type { Issue } from "../types";
import "../styles/variables.stylex";
import { ZendeskThemeVariables } from "../styles/variables.stylex";
type Props = {
  // Linear issue to be shown.
  issue: Issue;
  // Callback to be executed after clicking the link issue button
  onLink(): void;
};

/**
 * Shows a compact suggested-issue card when the app wants to surface likely matches before a ticket is linked.
 *
 * Use this in discovery flows such as similar-issue recommendations, where users need a quick way to inspect an issue
 * and link it without opening the full widget. See {@link IssueWidget} for the full linked state view.
 *
 * @param props The component properties described by {@link Props} .
 * @returns The rendered content.
 */
export const CompactIssueCard = (props: Props) => {
  const {
    issue,
    onLink
  } = props;
  const createdAt = new Date(issue.createdAt);
  const updatedAt = new Date(issue.updatedAt);
  const handleLink = (event: React.MouseEvent) => {
    event.preventDefault();
    onLink();
  };
  return <div className="sx-78zum5 sx-dt5ytf sx-mkeg23 sx-1y0btm7 sx-1ke0ykx sx-12oqio5 sx-c7ga6q">
      <a href={issue.url} target="_blank" rel="noopener noreferrer" className="sx-1s688f sx-uxw1ft sx-b3r6kr sx-lyipyv sx-12nagc">
        {issue.identifier} {issue.title}
      </a>
      <div className="sx-78zum5 sx-1qughib">
        <span>
          <span className="sx-fifm61 sx-8qomae">Status: {issue.state.name}</span>
          <span className="sx-t970qd sx-1xijbu4 sx-8qomae">&middot;</span>
          <span className="sx-fifm61 sx-8qomae">Created: {timeAgo.format(createdAt, "round")}</span>
          {issue.createdAt !== issue.updatedAt && <>
              <span className="sx-t970qd sx-1xijbu4 sx-8qomae">&middot;</span>
              <span className="sx-fifm61 sx-8qomae">Updated: {timeAgo.format(updatedAt, "round")}</span>
            </>}
        </span>
        <a onClick={handleLink} href="" className="sx-fifm61">
          Link issue
        </a>
      </div>
    </div>;
};